import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Alerts() {
  const [alerts, setAlerts] = useState({});

  useEffect(() => {
    const apiUrl = `https://frkyrillos.sgsa.ca/api/alerts`;
    axios.get(apiUrl)
      .then(response => {
        setAlerts(response.data);
      })
      .catch(error => {
        console.error(error);
        alert('Error fetching alerts');
      });
  }, []);

  return (
    <div>
      <h2>Alerts for Missing Confessions</h2>
      {Object.keys(alerts).map(grade => (
        <div key={grade}>
          <h3>Grade {grade}</h3>
          <ul>
            {alerts[grade].map(student => (
              <li key={student.id}>{student.first_name} {student.last_name} (Last Confession: {student.last_confession ? new Date(student.last_confession).toLocaleDateString() : 'Never'})</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default Alerts;
